import Transform from 'ember-data/transform';
import deserializeFilters from 'cio/utils/recipients-filter/deserialize';
import serializeFilters from 'cio/utils/recipients-filter/serialize';

export default class RecipientsJsonTransform extends Transform {
  deserialize(serialized: string) {
    return deserializeFilters(JSON.parse(serialized || '{}'));
  }

  serialize(deserialized: Record<string, any>) {
    return JSON.stringify(serializeFilters(deserialized));
  }
}

declare module 'ember-data/types/registries/transform' {
  export default interface TransformRegistry {
    'recipients-json': string | null;
  }
}
